module.exports = __webpack_public_path__ + "no-order-notification.modal.html";


//////////////////
// WEBPACK FOOTER
// ./customer/sections/order/no-order-notification/modals/no-order-notification.modal.html
// module id = 901
// module chunks = 0